module.exports = __webpack_public_path__ + "img/modelo-layout.d43cc7ca.jpg";